import { createGlobalStyle } from "styled-components";
import { getMobileBreakpoint } from "./globals";

const SectionSpacingCSS = createGlobalStyle`

  /************************************************
  * HEADER SECTION A
  ************************************************/
  
  .header-section-a > * {
    margin-top: 0px;
  }
  
  .header-section-a > *:first-child {
    margin-top: 0px;
  }
  
  .header-section-a + .image {
    margin-top: 20px;
  }
  
  .header-section-a + .tile-section-a {
    margin-top: 40px;
  }
  
  .header-section-a + .tile-section-b {
    margin-top: 40px;
  }
  
  .header-section-a + .tile-section-c {
    margin-top: 40px;
  }
  
  .header-section-a + .button-section {
    margin-top: 40px;
  }
  
  .header-section-a + .disclaimer {
    margin-top: 80px;
  }
  
  .header-section-a + .employer-search {
    margin-top: 20px;
  }
  
  /* Desktop Rules */
  
  @media (min-width: ${getMobileBreakpoint}) {
    .header-section-a + .image {
      margin-top: 40px;
    }
  
    .header-section-a + .tile-section-d {
      margin-top: 40px;
    }
  
    .header-section-a + .button-section {
      margin-top: 80px;
    }
  
    .header-section-a + .disclaimer {
      margin-top: 60px;
    }
  
    .header-section-a + .employer-search {
      margin-top: 32px;
    }
  }
  
  /************************************************
  * HEADER SECTION B
  ************************************************/
  
  .header-section-b > * {
    margin-top: 24px;

    @media (min-width: 1024px){
    margin-top: 30px;}
  }
  
  .header-section-b > *:first-child {
    margin-top: 0px;
  }
  
  .header-section-b + .image {
    margin-top: 20px;
  }
  
  .header-section-b + .tile-section-a {
    margin-top: 40px;
  }
  
  .header-section-b + .tile-section-b {
    margin-top: 40px;
  }
  
  .header-section-b + .tile-section-c {
    margin-top: 40px;
  }
  
  .header-section-b + .button-section {
    margin-top: 40px;
  }
  
  .header-section-b + .disclaimer {
    margin-top: 80px;
  }
  
  .header-section-b + .employer-search {
    margin-top: 20px;
  }
  
  /* Desktop Rules */
  
  @media (min-width: ${getMobileBreakpoint}) {
    .header-section-b + .image {
      margin-top: 40px;
    }
  
    .header-section-b + .button-section {
      margin-top: 80px;
    }
  
    .header-section-b + .disclaimer {
      margin-top: 60px;
    }
  
    .header-section-b + .employer-search {
      margin-top: 32px;
    }
  }
  
  /************************************************
  * BODY SECTION A
  ************************************************/
  
  .body-section-a > * {
    margin-top: 4px;
  }
  
  .body-section-a > *:first-child {
    margin-top: 0px;
  }
  
  .body-section-a + .image {
    margin-top: 20px;
  }
  
  .body-section-a + .tile-section-a {
    margin-top: 40px;
  }
  
  .body-section-a + .tile-section-b {
    margin-top: 40px;
  }
  
  .body-section-a + .tile-section-c {
    margin-top: 40px;
  }
  
  .body-section-a + .button-section {
    margin-top: 40px;
  }
  
  .body-section-a + .disclaimer {
    margin-top: 80px;
  }
  
  .body-section-a + .employer-search {
    margin-top: 20px;
  }
  
  @media (min-width: ${getMobileBreakpoint}) {
    .body-section-a + .image {
      margin-top: 40px;
    }
  
    .body-section-a + .button-section {
      margin-top: 80px;
    }
  
    .body-section-a + .disclaimer {
      margin-top: 60px;
    }
  
    .body-section-a + .employer-search {
      margin-top: 32px;
    }
  }
  
  /************************************************
  * BODY SECTION B
  ************************************************/
  
  .body-section-b > * {
    margin-top: 12px;
  }
  
  .body-section-b > *:first-child {
    margin-top: 0px;
  }
  
  .body-section-b + .image {
    margin-top: 20px;
  }
  
  .body-section-b + .tile-section-a {
    margin-top: 40px;
  }
  
  .body-section-b + .tile-section-b {
    margin-top: 40px;
  }
  
  .body-section-b + .tile-section-c {
    margin-top: 40px;
  }
  
  .body-section-b + .button-section {
    margin-top: 40px;
  }
  
  .body-section-b + .disclaimer {
    margin-top: 80px;
  }
  
  @media (min-width: ${getMobileBreakpoint}) {
    .body-section-b + .image {
      margin-top: 40px;
    }
  
    .body-section-b + .tile-section-d {
      margin-top: 40px;
    }
  
    .body-section-b + .button-section {
      margin-top: 80px;
    }
  
    .body-section-b + .disclaimer {
      margin-top: 80px;
    }
  
    .body-section-b + .employer-search {
      margin-top: 32px;
    }
  }
  
  /************************************************
  * IMAGE
  ************************************************/
  
  .image + .header-section-a {
    margin-top: 20px;
  }
  
  .image + .header-section-b {
    margin-top: 20px;
  }
  
  .image + .body-section-a {
    margin-top: 20px;
  }
  
  .image + .body-section-b {
    margin-top: 20px;
  }
  
  .image + .button-section {
    margin-top: 80px;
  }
  
  .image + .disclaimer {
    margin-top: 80px;
  }
  
  @media (min-width: ${getMobileBreakpoint}) {
    .image + .header-section-a {
      margin-top: 40px;
    }
  
    .image + .header-section-b {
      margin-top: 40px;
    }
  
    .image + .body-section-a {
      margin-top: 40px;
    }
  
    .image + .body-section-b {
      margin-top: 40px;
    }
  
    .image + .button-section {
      margin-top: 80px;
    }
  
    .image + .disclaimer {
      margin-top: 60px;
    }
  }
  
  /************************************************
  * TILE SECTION A
  ************************************************/
  
  .tile-section-a > * {
    margin-top: 20px;
  }
  
  .tile-section-a > *:first-child {
    margin-top: 0px;
  }
  
  .tile-section-a + .header-section-a {
    margin-top: 40px;
  }
  
  .tile-section-a + .header-section-b {
    margin-top: 40px;
  }
  
  .tile-section-a + .body-section-a {
    margin-top: 40px;
  }
  
  .tile-section-a + .body-section-b {
    margin-top: 40px;
  }
  
  .tile-section-a + .button-section {
    margin-top: 80px;
  }
  
  .tile-section-a + .disclaimer {
    margin-top: 40px;
  }
  
  @media (min-width: ${getMobileBreakpoint}) {
    .tile-section-a > * {
      margin-top: 24px;
    }
  
    .tile-section-a + .disclaimer {
      margin-top: 60px;
    }
  }
  
  /************************************************
  * TILE SECTION B
  ************************************************/
  
  .tile-section-b > * {
    margin-top: 32px;
  }
  
  .tile-section-b > *:first-child {
    margin-top: 0px;
  }
  
  .tile-section-b + .header-section-a {
    margin-top: 40px;
  }
  
  .tile-section-b + .header-section-b {
    margin-top: 40px;
  }
  
  .tile-section-b + .body-section-a {
    margin-top: 40px;
  }
  
  .tile-section-b + .body-section-b {
    margin-top: 40px;
  }
  
  .tile-section-b + .button-section {
    margin-top: 80px;
  }
  
  .tile-section-b + .disclaimer {
    margin-top: 80px;
  }
  
  @media (min-width: ${getMobileBreakpoint}) {
    .tile-section-b + .disclaimer {
      margin-top: 60px;
    }
  }
  
  /************************************************
  * TILE SECTION C
  ************************************************/
  
  .tile-section-c > * {
    margin-top: 40px;
  }
  
  .tile-section-c > *:first-child {
    margin-top: 0px;
  }
  
  .tile-section-c + .header-section-a {
    margin-top: 40px;
  }
  
  .tile-section-c + .header-section-b {
    margin-top: 40px;
  }
  
  .tile-section-c + .body-section-a {
    margin-top: 40px;
  }
  
  .tile-section-c + .body-section-b {
    margin-top: 40px;
  }
  
  .tile-section-c + .button-section {
    margin-top: 80px;
  }
  
  .tile-section-c + .disclaimer {
    margin-top: 80px;
  }
  
  @media (min-width: ${getMobileBreakpoint}) {
    .tile-section-c + .disclaimer {
      margin-top: 60px;
    }
  }
  
  /************************************************
  * TILE SECTION D
  ************************************************/
  
  .tile-section-d > * {
    margin-top: 60px;
  }
  
  .tile-section-d > *:first-child {
    margin-top: 0px;
  }
  
  @media (min-width: ${getMobileBreakpoint}) {
    .tile-section-d > * {
      margin-top: 80px;
    }
  
    .tile-section-d + .header-section-a {
      margin-top: 40px;
    }
  
    .tile-section-d + .header-section-b {
      margin-top: 40px;
    }
  
    .tile-section-d + .body-section-a {
      margin-top: 40px;
    }
  
    .tile-section-d + .body-section-b {
      margin-top: 40px;
    }
  
    .tile-section-d + .button-section {
      margin-top: 8px;
    }
  
    .tile-section-d + .disclaimer {
      margin-top: 60px;
    }
  }
  
  /************************************************
  * BUTTON SECTION
  ************************************************/
  
  .button-section > * {
    margin-top: 20px;
  }
  
  .button-section > *:first-child {
    margin-top: 0px;
  }
  
  .button-section + .header-section-a {
    margin-top: 40px;
  }
  
  .button-section + .header-section-b {
    margin-top: 40px;
  }
  
  .button-section + .body-section-a {
    margin-top: 40px;
  }
  
  .button-section + .body-section-b {
    margin-top: 40px;
  }
  
  .button-section + .image {
    margin-top: 80px;
  }
  
  .button-section + .tile-section-a {
    margin-top: 80px;
  }
  
  .button-section + .tile-section-b {
    margin-top: 80px;
  }
  
  .button-section + .tile-section-c {
    margin-top: 80px;
  }
  
  .button-section + .disclaimer {
    margin-top: 60px;
  }
  
  @media (min-width: ${getMobileBreakpoint}) {
    .button-section > * {
      margin-top: 24px;
    }
  
    .button-section + .header-section-a {
      margin-top: 80px;
    }
  
    .button-section + .header-section-b {
      margin-top: 80px;
    }
  
    .button-section + .body-section-a {
      margin-top: 80px;
    }
  
    .button-section + .body-section-b {
      margin-top: 80px;
    }
  
    .button-section + .disclaimer {
      margin-top: 80px;
    }
  }
  
  /************************************************
  * DISCLAIMER
  ************************************************/
  
  .disclaimer + .header-section-a {
    margin-top: 80px;
  }
  
  .disclaimer + .header-section-b {
    margin-top: 80px;
  }
  
  .disclaimer + .body-section-a {
    margin-top: 80px;
  }
  
  .disclaimer + .body-section-b {
    margin-top: 80px;
  }
  
  .disclaimer + .image {
    margin-top: 80px;
  }
  
  .disclaimer + .tile-section-a {
    margin-top: 80px;
  }
  
  .disclaimer + .tile-section-b {
    margin-top: 80px;
  }
  
  .disclaimer + .tile-section-c {
    margin-top: 80px;
  }
  
  .disclaimer + .button-section {
    margin-top: 80px;
  }
  
  .body-section-a + .error {
    margin-top: 4px;
  }
  
  @media (min-width: ${getMobileBreakpoint}) {
    .disclaimer + .tile-section-d {
      margin-top: 80px;
    }
  }
  
  /************************************************
  * ERROR
  ************************************************/
  
  .error + * {
    margin-top: 40px;
  }
  
  @media (min-width: ${getMobileBreakpoint}) {
    .error + * {
      margin-top: 40px;
    }
  }
  
  /************************************************
  * EMPLOYER SEARCH
  ************************************************/
  
  .employer-search + .header-section-a {
    margin-top: 32px;
  }
  
  .employer-search + .header-section-b {
    margin-top: 32px;
  }
  
  .employer-search + .body-section-a {
    margin-top: 32px;
  }
  
  .employer-search + .body-section-b {
    margin-top: 32px;
  }

  /************************************************
   * LINK
   ************************************************/

  .no-underlined-a {
    text-decoration:none !important;
    font-weight: 600;
  }
`;

export default SectionSpacingCSS;
